module.exports = __webpack_public_path__ + "img/examples-ru-7.2c83edfd.jpg";